import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import { Translate } from '@hydra/common/components';

export const Buttons = ({ disabled, editing, onEdit, onSave, onCancel, hideEdit }) => {
  return editing
    ? (
      <div>
        <Button
          onClick={onCancel}
          color='primary'
          disabled={disabled}
        >
          <Translate content='cancel' />
        </Button>
        <Button
          onClick={onSave}
          color='primary'
          variant='contained'
          disabled={disabled}
        >
          <Translate content='save' />
        </Button>
      </div>
      )
    : !hideEdit
        ? (
          <div>
            <Button
              onClick={onEdit}
              color='primary'
              disabled={disabled}
            >
              <Translate content='pdf_editor_edit' />
            </Button>
          </div>
          )
        : null;
};

Buttons.propTypes = {
  disabled: PropTypes.bool,
  editing: PropTypes.bool,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func
};

export default Buttons;
